import { render, staticRenderFns } from "./AIUpload.vue?vue&type=template&id=35fc6408&scoped=true"
import script from "./AIUpload.vue?vue&type=script&lang=js"
export * from "./AIUpload.vue?vue&type=script&lang=js"
import style0 from "./AIUpload.vue?vue&type=style&index=0&id=35fc6408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc6408",
  null
  
)

export default component.exports